import React from "react";

import { Subscribe } from "unstated";
import StateContainer from "../../../state/StateContainer";

import "./BackButton.css";
import deviceHelper from "../../../utils/helpers/deviceHelper";

function BackButtonIcon(props) {
  const { isApartmentPage } = props;
  const isMobile = deviceHelper.isMobileDevice();

  return (
    <div className="back-button-icon">
      <svg
        width={`${isApartmentPage ? `${isMobile ? '173px' : '200px'}` : "300px"}`}
        height={`100px`}
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 189 57"
        xmlSpace="preserve"
      >
        <metadata>
          <sfw xmlns="&ns_sfw;">
            <slices></slices>
            <sliceSourceBounds
              height="40.1"
              width="141"
              x="26.2"
              y="-49.4"
              bottomleftorigin="true"
            ></sliceSourceBounds>
          </sfw>
        </metadata>
        <polygon
          fill={props.unstated.state.menuColor}
          id="XMLID_1_"
          points="78.9,10.1 62.2,26.2 62.2,31.4 79.9,48.3 62.8,48.7 45.5,31.3 45.5,27.7 63.7,10.1 "
        />
        <polyline
          fill="#a3c475"
          id="XMLID_11_"
          points="78.8,20.5 70.8,28.5 70.8,30.3 78.8,38.3 "
        />
        <line
          id="XMLID_12_"
          x1="85.8"
          y1="30.3"
          x2="150.4"
          y2="30.3"
          troke="#000000"
          fill="#000000"
        />
        <path id="XMLID_5_" d="M79.6,10.1" troke="#000000" fill="#000000" />
        <polyline
          fill="#f2f2f2"
          id="XMLID_9_"
          points="79.9,9.7 62.7,26.4 62.7,31.4 80.9,48.3 151.4,48.3 153.8,47.4 156.4,46 158.8,44.4 
      160.6,42.9 162.6,40.8 164,38.6 165.2,36.1 166.2,33.8 166.6,31.8 166.6,30 166.6,27.5 166.3,25.4 165.8,23.4 165.4,21.9 164.7,20 
      163.5,18.3 162.4,16.8 161.8,15.9 160.5,14.7 159.6,13.9 158.8,13.1 157.3,12.2 156.1,11.5 154.9,11.1 153.9,10.6 146.6,10.5 
      79.9,10.1 "
        />
        <polyline
          stroke="#000000"
          fill="#f2f2f2"
          id="XMLID_7_"
          points="78.8,20 69.6,28.1 69.6,30.7 78.8,39.1 "
        />
        <line
          stroke="#000000"
          fill="#000000"
          id="XMLID_8_"
          x1="85.8"
          y1="30.3"
          x2="150.4"
          y2="30.3"
        />
        <polygon
          fill={props.unstated.state.menuColorSecondary}
          id="XMLID_6_"
          points="60.1,10.4 43.3,26.4 43.3,31.7 61.1,48.5 44,48.9 26.7,31.5 26.7,27.9 44.8,10.4 "
        />
      </svg>
    </div>
  );
}

function BackButtonIconWithUnstated(props) {
  return (
    <Subscribe to={[StateContainer]}>
      {(unstated) => <BackButtonIcon {...props} unstated={unstated} />}
    </Subscribe>
  );
}
export default BackButtonIconWithUnstated;
